module.exports = {
    // basic
    'view-no-matter-who-uploads-it': 'ver sin importar quién lo cargue',
    'view-only-if-they-upload-it': 'ver solo si lo suben',
    
    // raw
    // template
    'entry-type-access-permissions-help': (words) => `Permisos efectivos para "${words[0]}"`,
    'entry-type-access-permissions-title': (words) => `Permisos de tipo de entrada para "${words[0]}"`,
    'entry-type-access-companies-title': (words) => `Acceso a "${words[0]}" en "${words[1]}"`,
    'entry-type-access-company-help': (words) => `
        Las siguientes empresas tienen acceso a "${words[0]}" en "${words[1]}". <br />
        Al hacer clic en uno de los roles, se le mostrarán todos sus permisos efectivos.
    `,
    'entry-type-access-title': (words) => `Tipos de entrada en el pozo "${words[0]}"`,

};
